import {ReactComponent as BurgerIcon} from '../../../res/icon/burger.svg';

const BurgerButton = () => {
    return (
        <BurgerIcon className="burger-icon"></BurgerIcon>
    )
}

export default BurgerButton;
